import { render, staticRenderFns } from "./VueLightbox.vue?vue&type=template&id=791d0bbc&scoped=true"
import script from "./VueLightbox.vue?vue&type=script&lang=js"
export * from "./VueLightbox.vue?vue&type=script&lang=js"
import style0 from "./VueLightbox.vue?vue&type=style&index=0&id=791d0bbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791d0bbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('791d0bbc')) {
      api.createRecord('791d0bbc', component.options)
    } else {
      api.reload('791d0bbc', component.options)
    }
    module.hot.accept("./VueLightbox.vue?vue&type=template&id=791d0bbc&scoped=true", function () {
      api.rerender('791d0bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/downloadoverview/assets/vue/VueLightbox.vue"
export default component.exports